const USERS_PATH = 'users';

export const LOGIN_PATH = `${USERS_PATH}/login/`;
export const SIGNUP_PATH = `${USERS_PATH}/register/`;
export const SCRIPTS_PATH ='/scripts';
export const PATH ='/';

export const REFRESHTOKEN_PATH = 'users/token/refresh/';
export const SCRIPT_PATH = 'scripts';
export const SCRIPT_PATH_LIST = 'scripts/triggerList';
export const PROVIDERS_PATH = 'cloudProviders';
export const RESOURCES_PATH ='resources/deactivate';
export const CONTRACT_PATH_LIST = 'requesters';
export const CONTRACT_PATH = 'resources/deactivation';
export const CLOULD_ENVIRONMENTS = 'cloudEnvironments';
export const COMPONENTS = 'components';
export const TEMPLATES = 'templates'
export const CLOUD_PROVISIONER='cloudProvisionerTemplates'

